// Bookkeeping tasks are Other tasks whose type is flagged is_bookkeeping
// (bookkeeping, PST and GST returns -- seeded by clients migration 0060). The
// Tasks page's Bookkeeping tab is a view over the Other tasks split on this
// one rule, so changing a task's type moves it between the two tabs.

// Fallback for a type the server has not flagged (an older API, or a row
// whose type was created before the flag existed).
const BOOKKEEPING = /bookkeep|\bpst\b|\bgst\b|\bhst\b/i;

// `types` (the Other task types) is only consulted when the row carries a
// task_type id without its flag or name.
export function isBookkeepingTask(task, types = []) {
  if (!task) return false;
  if (task.task_type_is_bookkeeping === true) return true;
  const type = task.task_type != null
    ? types.find((t) => t.id === task.task_type)
    : null;
  if (type && type.is_bookkeeping === true) return true;
  const name = task.task_type_name || (type && type.name) || "";
  return BOOKKEEPING.test(name);
}

export function isBookkeepingType(type) {
  if (!type) return false;
  return type.is_bookkeeping === true || BOOKKEEPING.test(type.name || "");
}

// What the Bookkeeping tab's new-task row starts its Type field on.
export const DEFAULT_BOOKKEEPING_TYPE = "Bookkeeping";

export const REPEAT_LABELS = {
  monthly: "Monthly",
  quarterly: "Quarterly",
  annual: "Annually",
  none: "One-off",
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "2026-11-30" -> "Nov 30, 2026". Read from the string: new Date() on a
// bare date is UTC midnight, which is the day before in Saskatchewan.
export function formatDue(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  if (!m) return "";
  return `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}, ${m[1]}`;
}

// Today as "YYYY-MM-DD" in local time.
export function todayIso(now = new Date()) {
  const p = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
}

export function isFinished(task) {
  return Boolean(task?.is_completed) ||
    /^completed$/i.test((task?.status_name || "").trim());
}

export function isOverdue(task, today = todayIso()) {
  return !isFinished(task) && Boolean(task?.due_date) && task.due_date < today;
}

// Tile counts for the top of the tab, over the rows passed in.
export function tileCounts(tasks, today = todayIso()) {
  const open = tasks.filter((t) => !isFinished(t));
  return {
    active: open.length,
    waiting: open.filter((t) => /waiting/i.test(t.status_name || "")).length,
    review: open.filter((t) => /review/i.test(t.status_name || "")).length,
    overdue: open.filter((t) => isOverdue(t, today)).length,
  };
}

// Sort key for a period: start date, with period-less rows last.
export function periodKey(task) {
  return task?.period_start || "9999-99-99";
}
